import { render, staticRenderFns } from "./DocumentsBatchListCreate.vue?vue&type=template&id=f5f14d2c"
import script from "./DocumentsBatchListCreate.vue?vue&type=script&lang=js"
export * from "./DocumentsBatchListCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2296946445/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f5f14d2c')) {
      api.createRecord('f5f14d2c', component.options)
    } else {
      api.reload('f5f14d2c', component.options)
    }
    module.hot.accept("./DocumentsBatchListCreate.vue?vue&type=template&id=f5f14d2c", function () {
      api.rerender('f5f14d2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/documents/batch/views/DocumentsBatchListCreate.vue"
export default component.exports